import { SET_SMART_VALUE } from './constants';

export const setSMARTValue = smartValue => ({
    type: SET_SMART_VALUE,
    smartValue,
});



// WEBPACK FOOTER //
// ./src/containers/common/smart/actions.js